const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * MY ACCOUNT EVENTS                                                          *
 * - Addresses edit clicked                                                   *
 * - Order details clicked                                                    *
 * - Return item clicked                                                      *
 * - Tracking link clicked                                                    *
 * - Personal Details edit clicked                                            *
 * - New account registered                                                   *
 * - Return details clicked                                                   *
 * - Form field errors                                                        *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Addresses list click in edit button
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountAddressEdited, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'addresses'],
          ['action', 'edit'],
        ]),
      );
    },
  );

  // Order list click in order details
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountOrderDetailsClicked, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'orders'],
          ['action', 'details'],
        ]),
      );
    },
  );

  // Order list click in return item button
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountOrderReturnItemClicked, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'orders'],
          ['action', 'request_return'],
        ]),
      );
    },
  );

  // Order list click in tracking link
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountOrderTrackingLinkClicked, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'orders'],
          ['action', 'track_order'],
        ]),
      );
    },
  );

  // Personal Details click in edit button
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountPersonalDetailsEdited, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'personal_details'],
          ['action', 'edit'],
        ]),
      );
    },
  );

  // New account registered
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountRegistered, (location) => {
      pushEvent(
        createCustomEventGA4('account_register', [
          ['location', location],
        ]),
      );
    },
  );

  // RMA list click in return details
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.accountReturnDetailsClicked, () => {
      pushEvent(
        createCustomEventGA4('my_account', [
          ['item', 'returns'],
          ['action', 'details'],
        ]),
      );
    },
  );

  // Form field errors
  analyticsEventCenter.subscribe([
    ANALYTICS_EVENTS.formErrorShown,
    ANALYTICS_EVENTS.formFieldErrorShown,
  ],
  ({
    errorMessage,
    formName,
    pageType,
  }) => {
    const pageTypes = ANALYTICS_EVENTS.PAYLOADS.formFieldErrorShown.pageType;
    const typeByPageTypeAndFormName = {
      [pageTypes.account]: {
        dwfrm_address_addressId: 'address', // addressForm in Account
        dwfrm_profile: 'personal_info', // profileForm in Account page
      },
      [pageTypes.login]: {
        dwfrm_profile: 'register', // profileForm in Login page
        'login-form': 'login', // loginForm in Login page
      },
    };
    const type = typeByPageTypeAndFormName[pageType]?.[formName];
    if (type) {
      pushEvent(
        createCustomEventGA4('account_error', [
          ['type', type],
          ['message', errorMessage],
        ]),
      );
    }
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
